import { render, staticRenderFns } from "./news-list-comp.vue?vue&type=template&id=5b6a48e7&scoped=true&"
import script from "./news-list-comp.vue?vue&type=script&lang=js&"
export * from "./news-list-comp.vue?vue&type=script&lang=js&"
import style0 from "./news-list-comp.vue?vue&type=style&index=0&id=5b6a48e7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6a48e7",
  null
  
)

export default component.exports